import { SignalRReceiveEvent, SignalRSendEvent } from "../../Component/Model/Enum/SignalREvents";
import { SignalRHubs } from "../../Component/Model/Enum/SignalRHubs";
import { BaseClient } from "../BaseSignalRClient";
import config from "../../config";

export class VASubmissionProgressClient extends BaseClient {
    constructor() {
        super()
    }

    joinGroup = (username: string, updateStatusCallBack: any) => {
        this.sendPayload(SignalRSendEvent.JoinGroup, username, SignalRHubs.ConsolidationProgressHub, updateStatusCallBack,
            `${config.apiUrl.replace('/api/', '')}`);
    }

    removeListeners = (updateStatusCallBack: any) => {
        this.removeListener(SignalRReceiveEvent.UpdateStatus, updateStatusCallBack);
    };

}